import { CertificateDetail } from '../../../common/certificates/models/CertificateDetail';

export class OrganizationCertificateDetail extends CertificateDetail {
  // Currently there is no difference between these two models.
  // Keeping a different name for clarity and potential future expansion.
}
